import React from 'react';
import "./ExamsByPacks.css";
import NavBar from '../../Layouts/NavBar';
import ExamsByPacks from './ExamsByPacks';
//import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import UserInfoProvider from '../../Context/UserInfoContext';
import MedicalContextProvider from '../../Context/MedicalContext';
import PacksProvider from "../../Context/PacksContext";
import Footer from '../../Layouts/Footer';

function ExamsByPacksRoute() {
    return (
        <UserInfoProvider>
            <MedicalContextProvider>
            <PacksProvider>
            <div className="ExamsByPacksRoutePage">
                <div className="ExamsByPacksRouteNavBar">      
                        <NavBar/>
                     </div>
                <div className="ExamsByPacksRoute">
                    <ExamsByPacks/>
                </div>
                <div className="ExamsByPacksContact">
                    <Footer/>
                </div>
            </div>
</PacksProvider>
</MedicalContextProvider>
       </UserInfoProvider>
    );
}

export default ExamsByPacksRoute;